import { useEffect, useState } from 'react'
import { getDepositInfo, getDepositOptions } from '../adapters/transactions'
import { getPlayerBankAccounts } from '../utils/getPlayerBankAccounts'
import { getPaymentDepositLobby } from '../adapters/payments'
import { useBankAccountEvents } from './useBankAccountEvents'

export const useDepositData = () => {
  const [hasFirstTimeDeposit, setHasFirstTimeDeposit] = useState(false)
  const [depositLobbyData, setDepositLobbyData] = useState(null)
  const [usableBankAccounts, setUsableBankAccounts] = useState([])
  const [hasEligibleBankAccount, setHasEligibleBankAccount] = useState(false)

  const fetchDepositData = async () => {
    const depositResponse = await getDepositInfo()
    setHasFirstTimeDeposit(depositResponse.data.hasFirstTimeDeposit)

    const { usableBankAccounts: bankAccountList } =
      await getPlayerBankAccounts()
    setUsableBankAccounts(bankAccountList || [])

    const depositOptions = await getDepositOptions()      
    setHasEligibleBankAccount(depositOptions.data.hasEligibleBankAccount)

    const { data } = await getPaymentDepositLobby()
    if (data) {
      data.methods = data.methods?.sort(
        (a, b) => a.orderNumber - b.orderNumber
      )
      setDepositLobbyData(data)
    }
  }

  useEffect(() => {
    fetchDepositData()
  }, [])

  useBankAccountEvents([
    'bankAccountCreated'
  ], fetchDepositData)

  return {
    hasFirstTimeDeposit,
    depositLobbyData,
    usableBankAccounts,
    hasEligibleBankAccount,
  }
}
